import instance from "../../services/baseService";

// API function to get department details
export const getDepartmentDetails = async (departmentId) => {
    try {
        const response = await instance.get(`/api/v1/department/view/${departmentId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching department details:', error);
        throw error;
    }
};

// API function to get assigned users list
export const getAssignedUsersList = async (departmentId, page = 1, perpage = 25) => {
    try {
        const response = await instance.post(`/api/v1/department/assign/user/list/${departmentId}`, {
            page,
            perpage
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching assigned users list:', error);
        throw error;
    }
};

export const getAvailableUsersList = async (departmentId, searchQuery = '',page = 1, perpage = 25) => {
    try {
        const response = await instance.post(`/api/v1/department/available/user/list/${departmentId}`, {
            q: searchQuery,
            page,
            perpage
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching available users list:', error);
        throw error;
    }
};

// API function to assign user to department
export const assignUserToDepartment = async (departmentId, userId) => {
    try {
        const response = await instance.post(`/api/v1/department/assign/user/${departmentId}`, {
            user_id: userId
        });
        return response.data;
    } catch (error) {
        console.error('Error assigning user to department:', error);
        throw error;
    }
};

export const removeUserFromDepartment = async (departmentId, userId) => {
    try {
        const response = await instance.post(`/api/v1/department/remove/user/${departmentId}`, {
            user_id: userId
        });
        return response.data;
    } catch (error) {
        console.error('Error removing user from department:', error);
        throw error;
    }
};